<section class="py-16 md:py-20 lg:py-24 bg-main-light/50">
  <div class="container">
    <div class="max-w-2xl mx-auto text-center">
      <h2 class="text-3xl md:text-4xl font-semibold mb-3.5">{{ 'HOME.HOW_IT_WORKS.TITLE' | translate }}</h2>
      <p class="md:text-lg">
        {{ 'HOME.HOW_IT_WORKS.DESCRIPTION' | translate }}
      </p>

      <div role="tablist" [attr.aria-label]="'ACCESSIBILITY.CHOOSE_USER_TYPE' | translate"
           class="text-sm md:text-base mt-10 max max-w-md mx-auto grid grid-cols-2 p-1.5 rounded-full bg-main-100 font-medium">
        <button (click)="toggleActiveTab('client')" type="button" role="tab"
                [attr.aria-selected]="activeTab() === 'client'"
                [attr.aria-controls]="'client-content'"
                [id]="'client-tab'"
                class="py-3 px-5 {{activeTab() === 'client' ? 'text-black' : 'text-black/70'}} focus:outline-none focus:ring-2 focus:ring-main-500 focus:ring-offset-2"
                [class.bg-white]="activeTab() === 'client'"
                [class.rounded-full]="activeTab() === 'client'">
          {{ 'HOME.HOW_IT_WORKS.TABS.CLIENTS' | translate }}
        </button>
        <button (click)="toggleActiveTab('hairdresser')" type="button" role="tab"
                [attr.aria-selected]="activeTab() === 'hairdresser'"
                [attr.aria-controls]="'hairdresser-content'"
                [id]="'hairdresser-tab'"
                class="py-3 px-5 {{activeTab() === 'hairdresser' ? 'text-black' : 'text-black/70'}} focus:outline-none focus:ring-2 focus:ring-main-500 focus:ring-offset-2"
                [class.bg-white]="activeTab() === 'hairdresser'"
                [class.rounded-full]="activeTab() === 'hairdresser'">
          {{ 'HOME.HOW_IT_WORKS.TABS.HAIRDRESSERS' | translate }}
        </button>
      </div>
    </div>

    <div class="grid md:grid-cols-3 gap-5 mt-10 max-w-6xl mx-auto min-h-[260px]">
      @if (activeTab() === 'client') {
        <div role="tabpanel" id="client-content" [attr.aria-labelledby]="'client-tab'" class="contents">
          <div class="border-2 border-main-50 rounded-3xl p-8 bg-white flex flex-col">
            <lucide-icon [img]="Search" [size]="30" class="text-main-500 mb-3.5" aria-hidden="true"/>
            <h3 class="mb-1.5 text-xl font-medium">{{ 'HOME.HOW_IT_WORKS.CLIENT.STEP1.TITLE' | translate }}</h3>
            <p class="text-black/90 flex-grow">
              {{ 'HOME.HOW_IT_WORKS.CLIENT.STEP1.DESCRIPTION' | translate }}
            </p>
          </div>
          <div class="border-2 border-main-50 rounded-3xl p-8 bg-white flex flex-col">
            <lucide-icon [img]="CalendarDays" [size]="30" class="text-main-500 mb-3.5" aria-hidden="true"/>
            <h3 class="mb-1.5 text-xl font-medium">{{ 'HOME.HOW_IT_WORKS.CLIENT.STEP2.TITLE' | translate }}</h3>
            <p class="text-black/90 flex-grow">
              {{ 'HOME.HOW_IT_WORKS.CLIENT.STEP2.DESCRIPTION' | translate }}
            </p>
          </div>
          <div class="border-2 border-main-50 rounded-3xl p-8 bg-white flex flex-col">
            <lucide-icon [img]="Star" [size]="30" class="text-main-500 mb-3.5" aria-hidden="true"/>
            <h3 class="mb-1.5 text-xl font-medium">{{ 'HOME.HOW_IT_WORKS.CLIENT.STEP3.TITLE' | translate }}</h3>
            <p class="text-black/90 flex-grow">
              {{ 'HOME.HOW_IT_WORKS.CLIENT.STEP3.DESCRIPTION' | translate }}
            </p>
          </div>
        </div>
      } @else {
        <div role="tabpanel" id="hairdresser-content" [attr.aria-labelledby]="'hairdresser-tab'" class="contents">
          <div class="border-2 border-main-50 rounded-3xl p-8 bg-white flex flex-col">
            <lucide-icon [img]="UserRoundPlus" [size]="30" class="text-main-500 mb-3.5" aria-hidden="true"/>
            <h3 class="mb-1.5 text-xl font-medium">{{ 'HOME.HOW_IT_WORKS.HAIRDRESSER.STEP1.TITLE' | translate }}</h3>
            <p class="text-black/90 flex-grow">
              {{ 'HOME.HOW_IT_WORKS.HAIRDRESSER.STEP1.DESCRIPTION' | translate }}
            </p>
          </div>
          <div class="border-2 border-main-50 rounded-3xl p-8 bg-white flex flex-col">
            <lucide-icon [img]="Clock" [size]="30" class="text-main-500 mb-3.5" aria-hidden="true"/>
            <h3 class="mb-1.5 text-xl font-medium">{{ 'HOME.HOW_IT_WORKS.HAIRDRESSER.STEP2.TITLE' | translate }}</h3>
            <p class="text-black/90 flex-grow">
              {{ 'HOME.HOW_IT_WORKS.HAIRDRESSER.STEP2.DESCRIPTION' | translate }}
            </p>
          </div>
          <div class="border-2 border-main-50 rounded-3xl p-8 bg-white flex flex-col">
            <lucide-icon [img]="CalendarDays" [size]="30" class="text-main-500 mb-3.5" aria-hidden="true"/>
            <h3 class="mb-1.5 text-xl font-medium">{{ 'HOME.HOW_IT_WORKS.HAIRDRESSER.STEP3.TITLE' | translate }}</h3>
            <p class="text-black/90 flex-grow">
              {{ 'HOME.HOW_IT_WORKS.HAIRDRESSER.STEP3.DESCRIPTION' | translate }}
            </p>
          </div>
        </div>
      }
    </div>
  </div>
</section>
